import styled from "styled-components";

export const ButtonWithIconWrapper = styled.div`
  .button-with-icon-icon {
    margin-right: 6px;
  }

  .button-with-icon-button {
    height: auto;
  }
`;
